import type CrudAction from '../crud/CrudAction';

import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '../crud/CrudActionType';

const LandingsPage = async () => import('../../pages/LandingsPage.vue');
const LandingsMassEditModal = async () => import('./landings-mass-edit-modal/LandingsMassEditModal.vue');

export default function getLandingsRoutes(): RouteRecordRaw[] {
  return [
    {
      children: [
        {
          component: LandingsMassEditModal,
          name: 'edit-many-landings',
          path: String.raw`edit/mass/:ids(\d+)+`,
          props: (route) => ({
            landingIds: route.params.ids,
          }),
        },
      ],
      component: LandingsPage,
      meta: {
        title: 'Landers',
        useIn: ['navigation-tabs'],
      },
      name: 'landings',
      path: '/landings',
      props: () => ({
        crudAction: null,
      }),
    },
    {
      component: LandingsPage,
      name: 'create-landing',
      path: '/landings/create',
      props: (): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          type: CrudActionType.CREATE,
        },
      }),
    },
    {
      component: LandingsPage,
      name: 'edit-landing',
      path: '/landings/edit/:id',
      props: (
        route,
      ): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          id: route.params.id as string,
          type: CrudActionType.EDIT,
        },
      }),
    },
    {
      component: LandingsPage,
      name: 'clone-landing',
      path: '/landings/clone/:id',
      props: (
        route,
      ): {
        crudAction: CrudAction;
      } => ({
        crudAction: {
          id: route.params.id as string,
          type: CrudActionType.CLONE,
        },
      }),
    },
  ];
}
